import { render, staticRenderFns } from "./StoriesMoreReturn.vue?vue&type=template&id=344da5c0&scoped=true&"
import script from "./StoriesMoreReturn.vue?vue&type=script&lang=js&"
export * from "./StoriesMoreReturn.vue?vue&type=script&lang=js&"
import style0 from "./StoriesMoreReturn.vue?vue&type=style&index=0&id=344da5c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "344da5c0",
  null
  
)

export default component.exports